import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { onlineResourceShape } from '@bibliocommons/bc-prop-types';
import { selectOnlineResourcesForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import { OnlineResources } from '.';

export class OnlineResourcesContainer extends React.PureComponent {
  render() {
    return <OnlineResources {...this.props} />;
  }
}

OnlineResourcesContainer.propTypes = {
  onlineResources: ImmutablePropTypes.listOf(onlineResourceShape).isRequired
};

const mapStateToProps = state => ({
  onlineResources: selectOnlineResourcesForCurrentBib(state)
});

export default connect(mapStateToProps)(OnlineResourcesContainer);
